@if (!isMobileDevice && slides) {
  <swiper-container
    [class.single-item]="slides.length === 1"
    autoplay-delay="7000"
    autoplay-disable-on-interaction="false"
    pagination="true"
    pagination-clickable="true"
    space-between="50"
    navigation="true"
  >
    @for (slide of slides; track slide) {
      <swiper-slide>
        <img [src]="slide.image" alt="Image" />
        <div
          class="swiper-content-wrap clickable with-hover"
          (click)="showDetails(slide.url)"
        >
          <div class="swiper-content"></div>
          <!-- <a *ngIf="slide.url" routerLink="{{ slide.url }}" class="main-btn btn btn-primary btn-lg">Explore Collection</a> -->
        </div>
      </swiper-slide>
    }
  </swiper-container>
}
